import { Status } from "./status";
import { SupplierClassification } from "./supplier-classification";
import { SupplierClassificationAssignment } from "./supplier-classification-assignment";
import { SupplierContact } from "./supplier-contact";
import { SupplierCountry } from "./supplier-country";

export class Supplier {
  id?: number;
  code?: String;
  name?: String;
  supplierClassification?: SupplierClassification = {};
  address?:String;
  url?: string;  
  status?: Status = new Status();
  createdAt?: Date = new Date();
  supplierContacts?: SupplierContact[] = [] ;
  supplierCountries?: SupplierCountry[] = [];
  classifications?: SupplierClassificationAssignment[] = [];
  sourcing?: String;
}
